import { BaseCard, BaseTabs } from '@/shared/components'
import { SearchInput } from '@/shared/components/SearchInput/SearchInput'
import { OptionModel } from '@/shared/lib/types'
import { useIsMobile } from '@/shared/utils'
import { useState } from 'react'
import { RefferalsTable } from './referralsTable'
import { TeamleadsTable } from './teamleadsTable'
import { TraderReferralsListParamsStatusEnum } from 'syncra-api-client'
import { DatePickerWithRange } from '@/entities/datePicker'
import { DateRange } from 'react-day-picker'

export const RefTables = () => {
  const [refTabName, setRefTabName] = useState<'referrals' | 'teamleads'>('referrals')
  const [query, setQuery] = useState('')
  const isMobile = useIsMobile()
  const [selectedReferralStatus, setSelectedReferralStatus] = useState(TraderReferralsListParamsStatusEnum.Value1)
  const [selectedTeamleadsStatus, setSelectedTeamleadsStatus] = useState(0)
  const [dateRange, setDateRange] = useState<DateRange | undefined>(() => {
    const today = new Date()
    return {
      from: today,
      to: today
    }
  })

  // Обработчик изменения дат
  const handleDateChange = (range: DateRange | undefined) => {
    setDateRange(range)
  }

  const refTabsButton: OptionModel[] = [
    { label: 'Рефералы', value: 'referrals', index: 0 },
    //{ label: 'Тимлиды', value: 'teamleads', index: 1 },
  ]

  const refTabComponents = {
    referrals: (
      <RefferalsTable
        setQuery={setQuery}
        query={query}
        selectedIndex={selectedReferralStatus}
        selectFilterBtn={(index) => {
          setSelectedReferralStatus(index)
        }}
        dateRange={dateRange}
      />
    ),
    teamleads: (
      <TeamleadsTable
        setQuery={setQuery}
        selectedIndex={selectedTeamleadsStatus}
        selectFilterBtn={(index) => {
          setSelectedTeamleadsStatus(index)
        }}
      />
    ),
  }

  return (
    <BaseCard className="border-0 md:border-1" padding={isMobile ? 'none' : 'sm'}>
      <div className="flex justify-between items-start gap-2 mb-6 md:mb-[30px]">
        <div className="flex md:flex-row flex-col md:items-center md:gap-4 gap:[14px]">
          <BaseTabs
            tabs={refTabsButton}
            selectedTab={refTabName}
            onSelect={setRefTabName}
            direction="row"
            variant={isMobile ? 'primary' : 'secondary'}
          />
        </div>
        {!isMobile && (
          <div className="flex gap-2 items-center">
        <DatePickerWithRange
              onDateChange={handleDateChange}
              defaultPeriod="today"
              className="w-auto"
            />
            <SearchInput onChange={(event) => setQuery(event.target.value)} />
          </div>
        )}
      </div>
      {isMobile && (
        <DatePickerWithRange
          onDateChange={handleDateChange}
          defaultPeriod="today"
          className="w-auto mb-4"
        />
      )}
      {refTabComponents[refTabName]}
    </BaseCard>
  )
}
